module.exports = __webpack_public_path__ + "static/media/bird_fly11b.f0d9f0bd.gif";